import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import PopOverMenu from '../../PopOverMenu';
import { LoadingCard } from '../../cards';
import Events from './Events';

import styles from '../../../pages/ProfilePage/profilePage.scss';
import { getEventsData } from '../../../actions/profile-tab-actions';
import { EventScheduleTypes } from '../../../utils/eventConstants';

const eventMenuItems = [
    { value: EventScheduleTypes.UPCOMING, label: 'Upcoming events' },
    { value: EventScheduleTypes.RECENT, label: 'Recent events' },
];

const EventsTabContent = ({ auth, onScheduleTypeChange, isCurrentUserProfile, onSeeAllEventsClick, search, ctaData, eventScheduleType, isProfileIdUpdated, isUserLoggedIn }) => {
    const dispatch = useDispatch();
    const { data, isLoading } = useSelector(({ profileTabData }) => profileTabData?.events || {});
    const events = data || {};

    useEffect(() => {
        if (isUserLoggedIn && !data && isProfileIdUpdated) {
            dispatch(getEventsData());
        }
    }, [data, isProfileIdUpdated, isUserLoggedIn]);

    const handleOnEventTypeChange = (type) => {
        onScheduleTypeChange(type.value);
    };

    const eventType = eventMenuItems.find((item) => eventScheduleType === item.value);

    return (
        <div className={`${styles.events}`} data-testid="profile.events.content">
            <PopOverMenu
                menuItems={eventMenuItems}
                onSelected={handleOnEventTypeChange}
                alignLeft={true}
                data-testid="profile.events.type-dropdown"
            >
                <h6 className={`${styles.anchorClass} title pl8`}>
                    {eventType?.label} <i
                        className={`${styles.arrow} uts uts-expand`}
                    />
                </h6>
            </PopOverMenu>
            <>
                {isLoading ? (
                    <div className="row">
                        <div className={`col-12 col-md-6`}>
                            <LoadingCard />
                        </div>
                    </div>
                ) : (
                    <Events
                        auth={auth}
                        isCurrentUserProfile={isCurrentUserProfile}
                        force={false}
                        ctaData={ctaData}
                        search={search}
                        onHandleTabClick={onSeeAllEventsClick}
                        showAll={true}
                        events={events}
                        type={eventType?.value}
                    />
                )}
            </>
        </div>
    );
};

export default EventsTabContent;
